// document.querySelectorAll('.personality').forEach((bundle, bundleIdx) => {

//   const LOG  = (...a) => console.log(`[Bundle ${bundleIdx}]`, ...a);
//   const WARN = (...a) => console.warn(`[Bundle ${bundleIdx}]`, ...a);

//   // ── Elements ──────────────────────────────────────────────────────────────
//   const packs     = bundle.querySelectorAll('.personality__pack');
//   const selectors = bundle.querySelectorAll('.personality__selector');

//   // ── Currency format ───────────────────────────────────────────────────────
//   const moneyFormatEl  = bundle.querySelector('#shop-money-format') || document.querySelector('#shop-money-format');
//   const moneyFormat    = moneyFormatEl?.dataset.format || '{{amount}}';

//   const priceEls = {
//     1: bundle.querySelector('.personality-price-1'),
//     2: bundle.querySelector('.personality-price-2'),
//     3: bundle.querySelector('.personality-price-3')
//   };

//   const comparePriceEls = {
//     1: bundle.querySelector('.personality-comp-price-1'),
//     2: bundle.querySelector('.personality-comp-price-2'),
//     3: bundle.querySelector('.personality-comp-price-3')
//   };

//   const saveEls = {
//     1: bundle.querySelector('.personality__pack--1 .personality__save'),
//     2: bundle.querySelector('.personality__pack--2 .personality__save'),
//     3: bundle.querySelector('.personality__pack--3 .personality__save')
//   };

//   // ── Variant JSON ──────────────────────────────────────────────────────────
//   let variantMap = [];
//   try {
//     variantMap = JSON.parse(bundle.querySelector('.personality__variant-data').textContent);
//     LOG('variantMap OK:', variantMap);
//   } catch(e) {
//     WARN('variantMap parse FAILED:', e);
//     return;
//   }

//   // ── Helper: patch names list (IMPORTANT for matching) ─────────────────────
//   const patchOptionValues = [...bundle.querySelectorAll('.personality__dropdown option')]
//     .map(opt => opt.dataset.patchLabel);

//   // ── Price formatter ───────────────────────────────────────────────────────
//   function formatPrice(cents) {
//     const amount = (cents / 100).toFixed(2);
//     return moneyFormat
//       .replace('{{amount}}', amount)
//       .replace('{{amount_no_decimals}}', Math.round(cents / 100))
//       .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
//       .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)).replace('.', ','));
//   }

//   // ── Variant resolution ────────────────────────────────────────────────────
//   const numSizes = bundle.querySelectorAll(
//     '.personality__selector--1 .personality__sizes input[type="radio"]'
//   ).length || 3;

//   function resolveVariant(patchIndex, sizeIndex) {
//     const mapIndex = (patchIndex * numSizes) + sizeIndex;
//     const variant  = variantMap[mapIndex] || null;
//     LOG(`resolveVariant(patch=${patchIndex}, size=${sizeIndex}) → mapIndex=${mapIndex}`, variant || 'NOT FOUND');
//     return variant;
//   }

//   // ── Size availability controller ──────────────────────────────────────────
//   function updateSizeAvailability(selector) {
//     const select = selector.querySelector('.personality-variant-select');
//     const patchIndex = Number(select.value);
//     const patchName = patchOptionValues[patchIndex];

//     selector.querySelectorAll('.personality__size').forEach(label => {
//       const radio = label.querySelector('input');
//       const sizeLabel = radio.dataset.sizeLabel;

//       const variant = variantMap.find(v =>
//         v.patch === patchName &&
//         v.size === sizeLabel
//       );

//       const available = variant?.available;

//       label.classList.toggle('out-of-stock', !available);
//       radio.disabled = !available;

//       if (!available && radio.checked) {
//         radio.checked = false;
//       }
//     });
//   }

//   // ── Store + pricing ───────────────────────────────────────────────────────
//   function storeAndGetPrices(selector) {
//     const slot       = selector.dataset.selector;
//     const select     = selector.querySelector('.personality-variant-select');
//     const checkedRad = selector.querySelector('.personality__sizes input[type="radio"]:checked');

//     const patchIndex = Number(select.value);
//     const sizeIndex  = checkedRad ? Number(checkedRad.value) : 0;

//     const variant     = resolveVariant(patchIndex, sizeIndex);
//     const hiddenId    = selector.querySelector('.personality__stored-id');
//     const hiddenPrice = selector.querySelector('.personality__stored-price');

//     if (variant) {
//       hiddenId.value    = variant.id;
//       hiddenPrice.value = formatPrice(variant.price);
//       return { price: variant.price, compare: variant.compare };
//     }

//     hiddenId.value = '';
//     hiddenPrice.value = '';
//     return { price: 0, compare: 0 };
//   }

//   // ── Pack price calculation ────────────────────────────────────────────────
//   function updatePackDisplay(count, selectorList) {
//     let totalPrice   = 0;
//     let totalCompare = 0;

//     selectorList.forEach((sel, index) => {
//       if (index >= count) return;
//       const { price, compare } = storeAndGetPrices(sel);
//       totalPrice   += price;
//       totalCompare += compare || price;
//     });

//     if (priceEls[count]) {
//       priceEls[count].textContent = formatPrice(totalPrice);
//     }

//     if (comparePriceEls[count]) {
//       if (totalCompare > totalPrice) {
//         comparePriceEls[count].textContent = formatPrice(totalCompare);
//         comparePriceEls[count].closest('.personality__pack-compare-price')?.classList.remove('hidden');
//       } else {
//         comparePriceEls[count].textContent = '';
//         comparePriceEls[count].closest('.personality__pack-compare-price')?.classList.add('hidden');
//       }
//     }

//     if (saveEls[count]) {
//       if (totalCompare > totalPrice) {
//         const savePct = Math.round(((totalCompare - totalPrice) / totalCompare) * 100);
//         saveEls[count].textContent = `Save ${savePct}%`;
//         saveEls[count].style.display = '';
//       } else {
//         saveEls[count].style.display = 'none';
//       }
//     }
//   }

//   // ── Hidden input sync ─────────────────────────────────────────────────────
//   function updateVariantsInput() {
//     const activePack = bundle.querySelector('.personality__pack.active');
//     const count      = Number(activePack?.dataset.packCount || 1);

//     const variantsInput = document.querySelector('.personality-variants');
//     if (!variantsInput) return;

//     const ids = [];

//     selectors.forEach((sel, index) => {
//       if (index >= count) return;
//       const hiddenId = sel.querySelector('.personality__stored-id');
//       if (hiddenId?.value) ids.push(hiddenId.value);
//     });

//     variantsInput.value = JSON.stringify(ids);
//   }

//   // ── Master price update ───────────────────────────────────────────────────
//   function updatePrices() {
//     const activePack = bundle.querySelector('.personality__pack.active');
//     const count      = Number(activePack?.dataset.packCount || 1);

//     updatePackDisplay(count, [...selectors]);
//     updateVariantsInput();
//   }

//   // ── Init pricing all packs ────────────────────────────────────────────────
//   function calculateAllPackPrices() {
//     packs.forEach(pack => {
//       const count = Number(pack.dataset.packCount || 1);
//       updatePackDisplay(count, [...selectors]);
//     });
//   }

//   // ── Show selectors ────────────────────────────────────────────────────────
//   function showSelectors(count) {
//     selectors.forEach((selector, index) => {
//       const visible = index < count;

//       // ✅ FIX: always explicitly set both classes so no stale state remains,
//       // regardless of which pack was previously active or set as default.
//       if (visible) {
//         selector.classList.remove('hidden');
//         selector.classList.add('visible');
//       } else {
//         selector.classList.remove('visible');
//         selector.classList.add('hidden');
//       }

//       if (visible) {
//         const select = selector.querySelector('.personality-variant-select');
//         const slotIndex = Number(selector.dataset.slotIndex ?? index);
//         select.value = Math.min(slotIndex, select.options.length - 1);

//         const firstAvailableRadio = [...selector.querySelectorAll('.personality__sizes input[type="radio"]')]
//           .find(r => !r.disabled);

//         // ✅ FIX: uncheck all first, then check first available — avoids
//         // stale checked state when switching between packs.
//         selector.querySelectorAll('.personality__sizes input[type="radio"]').forEach(r => {
//           r.checked = false;
//         });

//         if (firstAvailableRadio) firstAvailableRadio.checked = true;

//         updateSizeAvailability(selector);
//       }
//     });

//     updatePrices();
//   }

//   // ── INIT ──────────────────────────────────────────────────────────────────

//   // ✅ FIX: if NO pack has .active (e.g. default_pack setting is missing),
//   // fall back to the first pack and add .active so the rest of the logic works.
//   let initPack = bundle.querySelector('.personality__pack.active');

//   if (!initPack) {
//     initPack = bundle.querySelector('.personality__pack');
//     if (initPack) initPack.classList.add('active');
//   }

//   calculateAllPackPrices();

//   if (initPack) {
//     showSelectors(Number(initPack.dataset.packCount));
//   }

//   selectors.forEach(sel => updateSizeAvailability(sel));

//   // ── Pack click ────────────────────────────────────────────────────────────
//   packs.forEach(pack => {
//     pack.addEventListener('click', () => {
//       packs.forEach(p => p.classList.remove('active'));
//       pack.classList.add('active');

//       showSelectors(Number(pack.dataset.packCount));
//       updatePrices();
//       updateVariantsInput();
//     });
//   });

//   // ── Dropdown change ───────────────────────────────────────────────────────
//   bundle.querySelectorAll('.personality-variant-select').forEach(select => {
//     select.addEventListener('change', () => {
//       const selector = select.closest('.personality__selector');
//       updateSizeAvailability(selector);
//       updatePrices();
//     });
//   });

//   // ── Size change ───────────────────────────────────────────────────────────
//   bundle.querySelectorAll('.personality__sizes input[type="radio"]').forEach(radio => {
//     radio.addEventListener('change', () => {
//       updatePrices();
//       updateVariantsInput();
//     });
//   });

// });



document.querySelectorAll('.personality').forEach((bundle, bundleIdx) => {

  const LOG  = (...a) => console.log(`[Bundle ${bundleIdx}]`, ...a);
  const WARN = (...a) => console.warn(`[Bundle ${bundleIdx}]`, ...a);

  // ── Elements ──────────────────────────────────────────────────────────────
  const packs     = bundle.querySelectorAll('.personality__pack');
  const selectors = bundle.querySelectorAll('.personality__selector');

  // ── Currency format ───────────────────────────────────────────────────────
  const moneyFormatEl  = bundle.querySelector('#shop-money-format') || document.querySelector('#shop-money-format');
  const moneyFormat    = moneyFormatEl?.dataset.format || '{{amount}}';

  const priceEls = {
    1: bundle.querySelector('.personality-price-1'),
    2: bundle.querySelector('.personality-price-2'),
    3: bundle.querySelector('.personality-price-3')
  };

  const comparePriceEls = {
    1: bundle.querySelector('.personality-comp-price-1'),
    2: bundle.querySelector('.personality-comp-price-2'),
    3: bundle.querySelector('.personality-comp-price-3')
  };

  const saveEls = {
    1: bundle.querySelector('.personality__pack--1 .personality__save'),
    2: bundle.querySelector('.personality__pack--2 .personality__save'),
    3: bundle.querySelector('.personality__pack--3 .personality__save')
  };

  // ── Variant JSON ──────────────────────────────────────────────────────────
  let variantMap = [];
  try {
    variantMap = JSON.parse(bundle.querySelector('.personality__variant-data').textContent);
    LOG('variantMap OK:', variantMap);
  } catch(e) {
    WARN('variantMap parse FAILED:', e);
    return;
  }

  // ── Helper: patch names list (IMPORTANT for matching) ─────────────────────
  const patchOptionValues = [...bundle.querySelectorAll('.personality__dropdown option')]
    .map(opt => opt.dataset.patchLabel);

  // ── Price formatter ───────────────────────────────────────────────────────
  function formatPrice(cents) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)).replace('.', ','));
  }

  // ── Variant resolution ────────────────────────────────────────────────────
  const numSizes = bundle.querySelectorAll(
    '.personality__selector--1 .personality__sizes input[type="radio"]'
  ).length || 3;

  function resolveVariant(patchIndex, sizeIndex) {
    const mapIndex = (patchIndex * numSizes) + sizeIndex;
    const variant  = variantMap[mapIndex] || null;
    LOG(`resolveVariant(patch=${patchIndex}, size=${sizeIndex}) → mapIndex=${mapIndex}`, variant || 'NOT FOUND');
    return variant;
  }

  // ── Size availability controller ──────────────────────────────────────────
  function updateSizeAvailability(selector) {
    const select = selector.querySelector('.personality-variant-select');
    const patchIndex = Number(select.value);
    const patchName = patchOptionValues[patchIndex];

    selector.querySelectorAll('.personality__size').forEach(label => {
      const radio = label.querySelector('input');
      const sizeLabel = radio.dataset.sizeLabel;

      const variant = variantMap.find(v =>
        v.patch === patchName &&
        v.size === sizeLabel
      );

      const available = variant?.available;

      label.classList.toggle('out-of-stock', !available);
      radio.disabled = !available;

      if (!available && radio.checked) {
        radio.checked = false;
      }
    });
  }

  // ── Store + pricing ───────────────────────────────────────────────────────
  function storeAndGetPrices(selector) {
    const slot       = selector.dataset.selector;
    const select     = selector.querySelector('.personality-variant-select');
    const checkedRad = selector.querySelector('.personality__sizes input[type="radio"]:checked');

    const patchIndex = Number(select.value);
    const sizeIndex  = checkedRad ? Number(checkedRad.value) : 0;

    const variant     = resolveVariant(patchIndex, sizeIndex);
    const hiddenId    = selector.querySelector('.personality__stored-id');
    const hiddenPrice = selector.querySelector('.personality__stored-price');

    if (variant) {
      hiddenId.value    = variant.id;
      hiddenPrice.value = formatPrice(variant.price);
      return { price: variant.price, compare: variant.compare };
    }

    hiddenId.value = '';
    hiddenPrice.value = '';
    return { price: 0, compare: 0 };
  }

  // ── Pack price calculation ────────────────────────────────────────────────
  function updatePackDisplay(count, selectorList) {
    let totalPrice   = 0;
    let totalCompare = 0;

    selectorList.forEach((sel, index) => {
      if (index >= count) return;
      const { price, compare } = storeAndGetPrices(sel);
      totalPrice   += price;
      totalCompare += compare || price;
    });

    // ── Manual pack discount (data-discount attribute on .personality__pack) ──
    // If discount is 0 (or missing) -> behavior is unchanged, exactly as before.
    // If discount > 0 -> the ORIGINAL total price becomes the compare price,
    // and the shown price is the total price minus the discount %.
    const packEl   = bundle.querySelector(`.personality__pack[data-pack-count="${count}"]`);
    const discount = Number(packEl?.dataset.discount || 0);

    let displayPrice   = totalPrice;
    let displayCompare = totalCompare;

    if (discount > 0) {
      displayCompare = totalPrice;
      displayPrice   = Math.round(totalPrice - (totalPrice * discount / 100));
    }

    if (priceEls[count]) {
      priceEls[count].textContent = formatPrice(displayPrice);
    }

    if (comparePriceEls[count]) {
      if (displayCompare > displayPrice) {
        comparePriceEls[count].textContent = formatPrice(displayCompare);
        comparePriceEls[count].closest('.personality__pack-compare-price')?.classList.remove('hidden');
      } else {
        comparePriceEls[count].textContent = '';
        comparePriceEls[count].closest('.personality__pack-compare-price')?.classList.add('hidden');
      }
    }

    if (saveEls[count]) {
      if (displayCompare > displayPrice) {
        const savePct = Math.round(((displayCompare - displayPrice) / displayCompare) * 100);
        saveEls[count].textContent = `Save ${savePct}%`;
        saveEls[count].style.display = '';
      } else {
        saveEls[count].style.display = 'none';
      }
    }
  }

  // ── Hidden input sync ─────────────────────────────────────────────────────
  function updateVariantsInput() {
    const activePack = bundle.querySelector('.personality__pack.active');
    const count      = Number(activePack?.dataset.packCount || 1);

    const variantsInput = document.querySelector('.personality-variants');
    if (!variantsInput) return;

    const ids = [];

    selectors.forEach((sel, index) => {
      if (index >= count) return;
      const hiddenId = sel.querySelector('.personality__stored-id');
      if (hiddenId?.value) ids.push(hiddenId.value);
    });

    variantsInput.value = JSON.stringify(ids);
  }

  // ── Master price update ───────────────────────────────────────────────────
  function updatePrices() {
    const activePack = bundle.querySelector('.personality__pack.active');
    const count      = Number(activePack?.dataset.packCount || 1);

    updatePackDisplay(count, [...selectors]);
    updateVariantsInput();
  }

  // ── Init pricing all packs ────────────────────────────────────────────────
  function calculateAllPackPrices() {
    packs.forEach(pack => {
      const count = Number(pack.dataset.packCount || 1);
      updatePackDisplay(count, [...selectors]);
    });
  }

  // ── Show selectors ────────────────────────────────────────────────────────
  function showSelectors(count) {
    selectors.forEach((selector, index) => {
      const visible = index < count;

      // ✅ FIX: always explicitly set both classes so no stale state remains,
      // regardless of which pack was previously active or set as default.
      if (visible) {
        selector.classList.remove('hidden');
        selector.classList.add('visible');
      } else {
        selector.classList.remove('visible');
        selector.classList.add('hidden');
      }

      if (visible) {
        const select = selector.querySelector('.personality-variant-select');
        const slotIndex = Number(selector.dataset.slotIndex ?? index);
        select.value = Math.min(slotIndex, select.options.length - 1);

        const firstAvailableRadio = [...selector.querySelectorAll('.personality__sizes input[type="radio"]')]
          .find(r => !r.disabled);

        // ✅ FIX: uncheck all first, then check first available — avoids
        // stale checked state when switching between packs.
        selector.querySelectorAll('.personality__sizes input[type="radio"]').forEach(r => {
          r.checked = false;
        });

        if (firstAvailableRadio) firstAvailableRadio.checked = true;

        updateSizeAvailability(selector);
      }
    });

    updatePrices();
  }

  // ── INIT ──────────────────────────────────────────────────────────────────

  // ✅ FIX: if NO pack has .active (e.g. default_pack setting is missing),
  // fall back to the first pack and add .active so the rest of the logic works.
  let initPack = bundle.querySelector('.personality__pack.active');

  if (!initPack) {
    initPack = bundle.querySelector('.personality__pack');
    if (initPack) initPack.classList.add('active');
  }

  calculateAllPackPrices();

  if (initPack) {
    showSelectors(Number(initPack.dataset.packCount));
  }

  selectors.forEach(sel => updateSizeAvailability(sel));

  // ── Pack click ────────────────────────────────────────────────────────────
  packs.forEach(pack => {
    pack.addEventListener('click', () => {
      packs.forEach(p => p.classList.remove('active'));
      pack.classList.add('active');

      showSelectors(Number(pack.dataset.packCount));
      updatePrices();
      updateVariantsInput();
    });
  });

  // ── Dropdown change ───────────────────────────────────────────────────────
  bundle.querySelectorAll('.personality-variant-select').forEach(select => {
    select.addEventListener('change', () => {
      const selector = select.closest('.personality__selector');
      updateSizeAvailability(selector);
      updatePrices();
    });
  });

  // ── Size change ───────────────────────────────────────────────────────────
  bundle.querySelectorAll('.personality__sizes input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', () => {
      updatePrices();
      updateVariantsInput();
    });
  });

});